import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";

const getAllProducts = {
    namespaced: true,
    state: {
        isProductsLoading: false,
        products: []
    },
    mutations: {
        GET_ALL_PRODUCTS_SUCCESS(state, response) {
            state.products = response.data.data;
        },
        GET_ALL_PRODUCTS_FAILURE(state, error) {
            console.log(error);
            state.products = [];
        },
        RESET_ALL_PRODUCTS(state) {
            state.products = [];
        },
    },
    actions: {
        getAllProductsRequest: function({dispatch, state}, payload={}) {
            let queryParams = {};

            let language = payload.language;
            let search = payload.search;

            queryParams = {
                language,
                search
            };

            let productsURL  = config.baseURLApi + "/products/autocomplete/getAll";
            state.isProductsLoading = true;

            let promise = sendRequest("get", productsURL, {}, {}, true, queryParams);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetAllProducts", result[1]);
                } else {
                    dispatch("failureGetAllProducts", result[1]);
                }
                state.isProductsLoading = false;
            });
        },
        resetAllProducts: function({commit})
        {
            commit("RESET_ALL_PRODUCTS");
        },
        successGetAllProducts: function({commit}, response) {
            commit("GET_ALL_PRODUCTS_SUCCESS", response);
        },
        failureGetAllProducts: function({commit}, error) {
            commit("GET_ALL_PRODUCTS_FAILURE", error);
        },
    }
}

export default getAllProducts;